import moment from 'moment';
//
import { IDealProduct } from 'store/field-options/types';
import { notApplicable } from 'components/deal-results/general-information/constants';

export function calculateStartAndEndValues(products?: IDealProduct[]): { start: Date; end: Date } | null {
  if (!products?.length) {
    return null;
  }

  type DateOrString = Date | string;

  interface DateRange {
    start: DateOrString | undefined;
    end: DateOrString | undefined;
  }

  const returnObject: DateRange = {
    start: products[0].startDate,
    end: products[0].endDate,
  };

  products.forEach(product => {
    if (!returnObject.start || (product.startDate && product.startDate < returnObject.start)) {
      returnObject.start = product.startDate as Date;
    }
    if (!returnObject.end || (product.endDate && product.endDate > returnObject.end)) {
      returnObject.end = product.endDate as Date;
    }
  });

  if (returnObject.start && returnObject.end) {
    return returnObject as { start: Date; end: Date };
  }

  return null;
}

// check if date or string, handle accordingly
export function generateProductPeriodString(startDate?: Date | string, endDate?: Date | string): string {
  if (!startDate || !endDate) {
    return notApplicable;
  }
  if (typeof startDate === 'string' && typeof endDate === 'string') {
    return `${startDate} - ${endDate}`;
  }
  return `${moment(startDate).format('MM/YYYY')} - ${moment(endDate).format('MM/YYYY')}`;
}

export function generateContractPeriodString(products?: IDealProduct[]): string {
  if (!products?.length) {
    return notApplicable;
  }
  const startAndEndValues = calculateStartAndEndValues(products);
  if (!startAndEndValues) {
    return notApplicable;
  }
  const { start, end } = startAndEndValues;
  return `${moment(start).format('MM/YYYY')} - ${moment(end).format('MM/YYYY')}`; // MM/YYYY - MM/YYYY
}

export function calculateNumOfMonths(products?: IDealProduct[]): number {
  if (!products?.length) {
    return 0;
  }
  const dateRange = calculateStartAndEndValues(products);
  if (!dateRange) {
    return 0;
  }
  const { start, end } = dateRange;
  const startMoment = moment(start, 'MM/YYYY').startOf('month');
  const endMoment = moment(end, 'MM/YYYY').startOf('month');
  return endMoment.diff(startMoment, 'months') + 1;
}

export function calculateNumOfMonthsUsingDates(
  start: Date | string | undefined,
  end: Date | string | undefined
): number {
  if (!start || !end) {
    return 0;
  }
  const startMoment = moment(start).startOf('month');
  const endMoment = moment(end).startOf('month');
  return endMoment.diff(startMoment, 'months') + 1;
}
